import React from "react"
import { Dots } from "react-activity"
import "react-activity/dist/Dots.css"

export default function ActivityLoader() {
    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                alignSelf: "center",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
            }}>
            <Dots
                size={45}
                color={"#FD0058"}
            />
        </div>
    )
}
